module.exports = __webpack_public_path__ + "img/shenzhen_2.457e6922.png";